import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetOneInformationAboutTheTargetGroupOfTheProject =
  createAsyncThunk(
    "OneInformationAboutTheTargetGroupOfTheProject/OneGetInformationAboutTheTargetGroupOfTheProject",
    async (tG_TargetedGroupId, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TargetedGroup/GetTG_TargetedGroup",
          {
            tG_TargetedGroupId: tG_TargetedGroupId,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "data");

        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

export const ValidateInformationAboutTheTargetGroupOfTheProject =
  createAsyncThunk(
    "InformationAboutTheTargetGroupOfTheProject/ValidateInformationAboutTheTargetGroupOfTheProject",
    async (InformationAboutTheTargetGroupOfTheProject, { rejectWithValue }) => {
      try {
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/TargetedGroup/ValidateTG_TargetedGroup",
          {
            myPNatureOfTargetedGrouproperty:
              InformationAboutTheTargetGroupOfTheProject.myPNatureOfTargetedGrouproperty,
            tG_TargetedGroupAgeId:
              InformationAboutTheTargetGroupOfTheProject.tG_TargetedGroupAgeId,
            expectedNumberOfBeneficiaries:
              InformationAboutTheTargetGroupOfTheProject.expectedNumberOfBeneficiaries,
            additionalInformation:
              InformationAboutTheTargetGroupOfTheProject.additionalInformation,
          }
        );

        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        if (response.data.success === true) {
          const arrayValidate = response.data.result.map((ele, ind) => {
            return ele.code;
          });
          return arrayValidate; // Return the extracted data
        }
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

const OneInformationAboutTheTargetGroupOfTheProject = createSlice({
  name: "OneInformationAboutTheTargetGroupOfTheProject",
  initialState: {
    OneInformationAboutTheTargetGroupOfTheProject: {},
    loadingOneInformationAboutTheTargetGroupOfTheProject: false,
    errorOneInformationAboutTheTargetGroupOfTheProject: null,

    OneInformationAboutTheTargetGroupOfTheProjectValidate: [],
    loadingOneInformationAboutTheTargetGroupOfTheProjectValidate: false,
    errorOneInformationAboutTheTargetGroupOfTheProjectValidate: null,
  },
  reducers: {
    resetValidateList: (state, action) => {
      state.OneInformationAboutTheTargetGroupOfTheProjectValidate = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        GetOneInformationAboutTheTargetGroupOfTheProject.pending,
        (state, action) => {
          state.loadingOneInformationAboutTheTargetGroupOfTheProject = true;
          state.OneInformationAboutTheTargetGroupOfTheProject = action.payload;
          state.errorOneInformationAboutTheTargetGroupOfTheProject = null;
        }
      )
      .addCase(
        GetOneInformationAboutTheTargetGroupOfTheProject.fulfilled,
        (state, action) => {
          state.loadingOneInformationAboutTheTargetGroupOfTheProject = false;
          state.OneInformationAboutTheTargetGroupOfTheProject = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetOneInformationAboutTheTargetGroupOfTheProject.rejected,
        (state, action) => {
          state.loadingOneInformationAboutTheTargetGroupOfTheProject = false;
          state.errorGetOneInformationAboutTheTargetGroupOfTheProject =
            action.payload;
        }
      )

      .addCase(
        ValidateInformationAboutTheTargetGroupOfTheProject.pending,
        (state, action) => {
          state.loadingOneInformationAboutTheTargetGroupOfTheProjectValidate = true;
          state.OneInformationAboutTheTargetGroupOfTheProjectValidate =
            action.payload;
          state.errorOneAdvertisingAndMediaPlanForTheProjectValidate = null;
        }
      )
      .addCase(
        ValidateInformationAboutTheTargetGroupOfTheProject.fulfilled,
        (state, action) => {
          state.loadingOneInformationAboutTheTargetGroupOfTheProjectValidate = false;
          state.OneInformationAboutTheTargetGroupOfTheProjectValidate =
            action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        ValidateInformationAboutTheTargetGroupOfTheProject.rejected,
        (state, action) => {
          state.loadingOneInformationAboutTheTargetGroupOfTheProjectValidate = false;
          state.errorOneAdvertisingAndMediaPlanForTheProjectValidate =
            action.payload;
        }
      );
  },
});
export const { resetValidateList } =
  OneInformationAboutTheTargetGroupOfTheProject.actions;
export default OneInformationAboutTheTargetGroupOfTheProject.reducer;
